import { Box, Paper, Typography } from '@mui/material'
import { APP_BOOT_MARK, APP_NAME } from '@/helpers/constants'
import styles from './index.module.scss'

/** Shown while lazy-loaded route chunks download (SaaS-scale bundle strategy). */
function MainRouteFallback() {
  return (
    <Box component="section" className={styles.region} aria-busy="true" aria-label={`Loading ${APP_NAME}`}>
      <Paper className={styles.panel} elevation={0}>
        <Box className={styles.brand}>
          <Typography component="p" className={styles.brandMark}>
            {APP_BOOT_MARK}
          </Typography>
          <Typography component="p" className={styles.brandName}>
            {APP_NAME}
          </Typography>
        </Box>
        <Box className={styles.shimmer} />
      </Paper>
    </Box>
  )
}

export default MainRouteFallback
